import { FC, ReactNode } from "react";

import { DesignToken, Heading, SpacingToken, Text } from "@livechat/design-system-react-components";

import Flex, { IFlexProps } from "components/layout/Flex";
import { withVar } from "themes/helpers";

interface IEmptyStateProps {
  title: string;
  children: ReactNode;
  icon?: ReactNode;
  actions?: ReactNode;
  alignSelf?: IFlexProps["alignSelf"];
  dataTestId?: string;
}

export const EmptyState: FC<IEmptyStateProps> = ({ title, children, icon, alignSelf, dataTestId, actions }) => (
  <Flex
    column
    justifyContent="center"
    alignItems="center"
    gap={withVar(SpacingToken.Spacing3)}
    padding={`${withVar(SpacingToken.Spacing12)} ${withVar(SpacingToken.Spacing6)}`}
    maxWidth="562px"
    alignSelf={alignSelf}
    data-testid={dataTestId}
  >
    {icon}
    <Heading customColor={withVar(DesignToken.ContentBasicPrimary)}>{title}</Heading>
    <Text customColor={withVar(DesignToken.ContentBasicPrimary)} textAlign="center">
      {children}
    </Text>
    <Flex gap={withVar(SpacingToken.Spacing2)}>{actions}</Flex>
  </Flex>
);
